/** Footer logo strip combination id (non-home pages). */
export const FOOTER_TRUST_MARKERS_COMBINATION_ID = 'home-variant-8'
